module.exports = __webpack_public_path__ + "img/srb.fca3f955.png";